import { DepreciationType } from "../validations";

export const defaultValueDepreciation = (value: Partial<DepreciationType> = {}): DepreciationType => ({
    depreciation_period: value.depreciation_period?.toString() || "",
    depreciation_methode: value.depreciation_methode || "1",
    depreciation_expences: 0,
    depreciation_rate: value.depreciation_rate || 0,
    asset_id: value.asset_id || undefined,
    asset_infodepreciation_id: value.asset_infodepreciation_id || undefined
});
